
import createIconComponent from '../utils/createIconComponent';
import { SVG_BANK_CARD_OUTLINED } from '../../../dist';
import React from 'react';
const BankCardOutlinedIcon = createIconComponent({ content: SVG_BANK_CARD_OUTLINED, height: 24, width: 24 });
BankCardOutlinedIcon.displayName = 'BankCardOutlinedIcon';
export default BankCardOutlinedIcon;
